import React, { useEffect, useState } from "react";
import { QUERIES } from "../config/apiConfig";
import axios from "../config/axiosInstance";
import { uploadPDF } from "../utils/utils";

const usePDF = (componentRef, info, queryId, data) => {
  const [pdfURL, setPdfURL] = useState("");

  const handleClickDownloadPDF = async (type = null) => {
    try {
      const binaryString = atob(pdfURL);
      const len = binaryString.length;
      const arrayBuffer = new Uint8Array(len);

      for (let i = 0; i < len; i++) {
        arrayBuffer[i] = binaryString.charCodeAt(i);
      }

      const blob = new Blob([arrayBuffer], { type: "application/pdf" });

      if (type) {
        return blob;
      }

      const blobUrl = URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = `${info}.pdf`;
      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error("Erro ao abrir PDF:", error);
    }
  };

  useEffect(() => {
    const upload = async () => {
      const response = await uploadPDF(componentRef, info, queryId);
      setPdfURL(response || "");
    };

    setTimeout(() => {
      if (data) {
        upload();
      }
    }, 1000);
  }, [data]);

  useEffect(() => {
    const processPDF = async () => {
      if (pdfURL) {
        const binaryString = atob(pdfURL);
        const len = binaryString.length;
        const arrayBuffer = new Uint8Array(len);

        for (let i = 0; i < len; i++) {
          arrayBuffer[i] = binaryString.charCodeAt(i);
        }

        const blob = new Blob([arrayBuffer], { type: "application/pdf" });

        const formData = new FormData();
        formData.append("queryId", queryId);
        formData.append("parameter", info);
        formData.append("pdfFile", blob, "arquivo.pdf");

        await axios.post("/generate/pdf-with-file", formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });
      }
    };

    processPDF();
  }, [pdfURL]);

  return { pdfURL, setPdfURL, handleClickDownloadPDF };
};

export default usePDF;
